import React from "react";
import StatsCard from "../shared/StatsCard";

const TrackFeatureCard = () => {
  return (
    <div className="bg-primary rounded-[32px] w-[300px] h-[500px] sm:w-[330px] sm:h-[550px] md:w-[360px] md:h-[600px] py-6 flex flex-col relative items-center border border-black border-dashed overflow-hidden">
      <h2 className="text-black text-[24px] sm:text-[26px] md:text-[28px] font-bold text-center mb-6 sm:mb-8">
        Track
      </h2>
      <div className="absolute top-1/2 left-[60%] -translate-x-1/2 -translate-y-1/2">
        <StatsCard
          score="96%"
          nextReview="4 days"
          totalTime="140m"
          question="What is the formula for kinetic energy?"
        />
      </div>
    </div>
  );
};

export default TrackFeatureCard;
